// extracted by mini-css-extract-plugin
module.exports = {"theme":"lohono-black-module__theme___YEbbW"};